<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n'
import Spain from '../../assets/images/flags/spain.svg'
import UnitedStatesOfAmerica from '../../assets/images/flags/united-states-of-america.svg'

const { locale } = useI18n()
const showLanguageMenu = ref(false)

const languages = [
  { code: 'es', name: 'Español', flag: Spain },
  { code: 'en', name: 'English', flag: UnitedStatesOfAmerica }
]

// Inicializar con el idioma guardado en localStorage o el valor por defecto
const savedLanguage = localStorage.getItem('userLanguage')
locale.value = savedLanguage || 'es'
const currentLanguage = ref(languages.find(lang => lang.code === locale.value) || languages[0])

const changeLanguage = (langCode: string) => {
  locale.value = langCode
  localStorage.setItem('userLanguage', langCode)
  currentLanguage.value = languages.find(lang => lang.code === langCode) || languages[0]
  showLanguageMenu.value = false
}
</script>

<template>
  <div class="relative">
    <button
      @click="showLanguageMenu = !showLanguageMenu"
      class="p-2 rounded-lg text-secondary-500 hover:bg-secondary-100 dark:hover:bg-secondary-700 transition-colors flex items-center gap-2"
    >
      <img :src="currentLanguage.flag" class="w-6 h-6" />
    </button>

    <!-- Language Menu -->
    <div
      v-if="showLanguageMenu"
      class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-secondary-800 ring-1 ring-black ring-opacity-5 z-50"
    >
      <div class="py-1">
        <button
          v-for="lang in languages"
          :key="lang.code"
          @click="changeLanguage(lang.code)"
          class="w-full px-4 py-2 text-left text-sm text-secondary-700 dark:text-secondary-200 hover:bg-secondary-100 dark:hover:bg-secondary-700 flex items-center gap-2"
        >
          <img :src="lang.flag" class="w-6 h-6" />
          <span>{{ lang.name }}</span>
        </button>
      </div>
    </div>
  </div>
</template>
